import { signInWithGoogle } from './FirebaseService';
import axiosInstance from './BaseService';

export const loginWithGoogle = async () => {
  try {
    const googleUser = await signInWithGoogle();
    
    // Send the ID token to backend for verification
    const response = await axiosInstance.post('/google-login', {
      idToken: googleUser.accessToken
    });
    
    return response.data;
  } catch (error: any) {
    console.error('Google login error:', error);
    throw new Error(error.response?.data?.message || 'Google login failed');
  }
};